import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { title, description, linkText, link, photo } = props;

	return (
		<React.Fragment>
			<div className="project">
				<Link to={link}>
					<div className="project-container">
						<div className="project-image-wrapper">
							<img src={photo} alt={`${title} service example`} className="project-image"/>
							<div className="project-overlay">
								<span className="view-more">
									{linkText} <FontAwesomeIcon icon={faArrowRight} />
								</span>
							</div>
						</div>
						<div className="project-content">
							<h3 className="project-title">{title}</h3>
							<p className="project-description">{description}</p>
						</div>
					</div>
				</Link>
			</div>
		</React.Fragment>
	);
};

export default Project;
